type SheetTitleProps = {
  logoSrc: string | null;
  name: string;
};

/** Logo and classroom name at the top left of the sheet; the sheet itself decides on the outline. */
export function SheetTitle({ logoSrc, name }: SheetTitleProps) {
  return (
    <>
      {logoSrc && <img src={logoSrc} alt="Klaslogo" className="h-[2.2em] w-auto rounded-md" />}
      <span className="text-[1.6em] font-extrabold leading-none" style={{ fontFamily: 'var(--font-heading)' }}>
        {name}
      </span>
    </>
  );
}
